
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/401",
      function () {
        return require("private-next-pages/401.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/401"])
      });
    }
  